import { InteractiveMap } from "../common/interactiveMap";

export function initRegionalOfferings(razor) {
    new InteractiveMap({
        apiKey: razor.apiKey,
        mapElementId: "map",
        mapId: razor.mapId,
        listElementId: "list",
        listContainerId: "listContainer",
        mapBtnId: "mapBtn",
        listBtnId: "listBtn",
        center: { lat: 64.8, lng: 26.219 },
        zoom: 5,
        maxZoom: 18,
        dataRequest: {
            type: "GET",
            dataType: "json",
            url: "/RegionalOfferingApi/GetMapData"
        },

        // #region Site/Map-specific code
        onLoad: function (data) {

            // #region Filter/Layers switch
            const btnFilters = $("#filtersBtn");
            const btnLayers = $("#layersBtn");
            const blockFilters = $("#industryfilter");
            const blockLayers = $("#layerfilter");

            const toggleBtnAndBlock = (btn, block, show) => {
                block.toggleClass("d-none", !show);
                btn.toggleClass("button-active", show);
                btn.find(".iconWhite").toggleClass("d-none", !show);
                btn.find(".iconBlue").toggleClass("d-none", show);
            };
            const toggleFiltersOrLayers = (showFilters) => {
                toggleBtnAndBlock(btnFilters, blockFilters, showFilters);
                toggleBtnAndBlock(btnLayers, blockLayers, !showFilters);
            };
            btnFilters.on("click", () => toggleFiltersOrLayers(true));
            btnLayers.on("click", () => toggleFiltersOrLayers(false));
            // #endregion


            // #region Markers
            let rdas = data.rdas;
            let markers = this.createMarkers(rdas);
            this.createCluster(markers);
            // #endregion

            // #region KML Layers
            let kml = {};
            const kmlLayers = razor.kmlLayers;
            for (let name in kmlLayers) {
                kml[name] = { layer: null, kmlFileId: name, kmlUrl: kmlLayers[name] };
                let checkBox = $('#' + name);
                checkBox.on("change", () => {
                    if (checkBox.prop('checked')) {
                        this.showKmlLayer(kml[name]);
                    } else {
                        this.hideKmlLayer(kml[name]);
                    }
                });
                if (checkBox.prop('checked')) {
                    this.showKmlLayer(kml[name]);
                }
            }
            // #endregion

            // #region Filters
            const processRDAs = () => {
                let selectedSubId = $(".subindustry:checked").val();
                const exists = (x) => x !== undefined && x !== null && x !== "";
                rdas.forEach((item) => {
                    let show = exists(selectedSubId)
                        && exists(item.bf_RDA_bf_BFSubIndustry_bf_BFSubIndustry)
                        && exists(item.bf_RDA_bf_BFSubIndustry_bf_BFSubIndustry.find(i => i.bf_bfsubindustryid === selectedSubId));
                    this.toggleItem(item, show);
                    // Update links with selected subindustry
                    $(`[data-rda-id=${item.bf_rdaid}]`).attr("href", this.templates.url(item));
                });
            }
            this.options.onTabSwitch = () => {
                processRDAs();
            }

            let that = this;
            $('#reset-all').on('click', (e) => {
                e.preventDefault();
                $("input[id^=sub-]:checked").prop("checked", false);
                that.resetMap();
                processRDAs();
                return false;
            });

            $(".subindustry").on("change", processRDAs);
            // #endregion

            processRDAs();
        },
        // #endregion

        // #region Templates
        templates: (mapInstance) => {
            return {
                id: (item) => item.bf_rdaid,
                title: (item) => item.bf_offeringtitle,
                icon: (item) => {
                    // return png images because of recommendation by google to use raster images (pmg or jpg) for markers to avoid lag when map is redrawn.
                    // See more here: https://developers.google.com/maps/optimization-guide#using_raster_images_for_markers
                    return {
                        url: '/img/data-center/pointer-blue.png',
                        scaledSize: new google.maps.Size(41, 49)
                    };
                },
                url: (item) => {
                    const selectedSub = $(".subindustry:checked");
                    const selectedSubId = selectedSub.val();
                    const selectedSubName = selectedSub.attr("data-name");
                    return `${location.origin}/${razor.profileURL}?name=${item.slug}&industry=${selectedSubName}&id=${item.bf_rdaid}&industryId=${selectedSubId}`;
                },
                infoWindow: (item) => {
                    return `<div class="map-item my-1 d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap">
                                <div class="map-item__title me-2 mb-1">${item.bf_offeringtitle}</div>
                                <a class="btn btn--secondary flex-grow-1 flex-md-grow-0 flex-shrink-0 map-item__link" data-rda-id="${item.bf_rdaid}" href="${mapInstance.templates.url(item)}">${razor.profileLinkText}</a>
                            </div>`;
                },
                listItem: (item) => {
                    return `<tr class="row-container border-investment-list" id="${item.bf_rdaid}">
                                <td class="mobile-investment-list filter-checkbox-row-investment-opportunities-list">
                                    <a data-rda-id="${item.bf_rdaid}" href="${mapInstance.templates.url(item)}">${item.bf_offeringtitle}</a>
                                </td>
                                <td class="mobile-colocations-list">
                                    <img loading="lazy" src="/img/data-center/pointer-blue.svg" class="pointer-icon-list" width="20" height="20">
                                    ${item.bf_rdacity && item.bf_rdacity !== "" ? `<span>${item.bf_rdacity}</span>` : ''}
                                </td>
                            </tr>`;
                }
            }
        }
        // #endregion
    });
}